"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Ensure this variable is always defined and is a boolean, defaulting to false.
// The original variable is defined in '.storybook/main.js'.
window.IS_STORYBOOK = window.IS_STORYBOOK || false;
require("./libraries/alpine");
require("./libraries/gsap");
